import { useState, useEffect } from 'react';
import { HelpButton } from './HelpModal';
import { ArrowRight, Scale } from 'lucide-react';

const FIELDS = [
  { key: 'bunkers', label: 'Bunkers (Fuel)', help: 'bunkers' },
  { key: 'fw', label: 'Fresh Water', help: 'fw' },
  { key: 'ballast', label: 'Ballast Water', help: 'ballast' },
  { key: 'stores', label: 'Stores & Provisions', help: 'stores' },
  { key: 'slops', label: 'Slops', help: 'slops' },
  { key: 'others', label: 'Other Weights', help: 'constants' },
] as const;

interface ConstantsFormProps {
  initial: Record<string, number>;
  onSubmit: (constants: Record<string, number>) => void;
}

export default function ConstantsForm({ initial, onSubmit }: ConstantsFormProps) {
  const [values, setValues] = useState<Record<string, number>>(initial);
  const [, setHelpId] = useState<string | null>(null);

  useEffect(() => { setValues(initial); }, [initial]);

  const total = Object.values(values).reduce((a, b) => a + (b || 0), 0);

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="glass rounded-xl p-4 flex items-center gap-3">
        <Scale className="w-5 h-5 text-ocean-400" />
        <div className="text-sm text-navy-300">Enter all weights on board that are <strong>not cargo</strong></div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {FIELDS.map((f) => (
          <div key={f.key} className="card-premium p-3">
            <label className="label-premium text-xs flex items-center">
              {f.label}
              <HelpButton helpId={f.help} onClick={setHelpId} />
            </label>
            <input
              type="number"
              step="0.01"
              className="input-premium"
              value={values[f.key] || ''}
              onChange={(e) => setValues((prev) => ({ ...prev, [f.key]: e.target.value === '' ? 0 : parseFloat(e.target.value) }))}
              placeholder="0.00"
            />
          </div>
        ))}
      </div>

      <div className="glass rounded-xl p-4 flex items-center justify-between">
        <span className="text-sm text-navy-400">Total Constants</span>
        <span className="text-lg font-bold text-ocean-400 font-mono">{total.toFixed(2)} MT</span>
      </div>

      <button type="button" onClick={() => onSubmit(values)} className="btn-primary w-full flex items-center justify-center gap-2">
        Review Results <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}
